<template>
  <div>
    <el-button type="text" @click="saveCollect" v-if="isShow">{{isFavorite ? '已收藏' : '我要收藏'}}</el-button>

    <dir-selector
      ref="dirSelector"
      categoryType="ResourceFavoriteDir"
      @ensure="ensure"
    ></dir-selector>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import {WinForm, Category} from '@/libs';
import {CommonService,FavoriteService} from '@/service';

import DirSelector from '@/components/dir-selector/index.vue'

export default{
  props: {
    dataSource: { default: () => ({}) }
  },
  data() {
    return {
      isFavorite: false,
    }
  },
  components: { DirSelector },
  computed: {
    isShow() {
      const filepath = this.dataSource.filepath || '';
      const subcount = this.dataSource.subcount || 0;
      return filepath && subcount === 0;
    }
  },
  watch: {
    'dataSource.id': function(id){
      id && (this.existFavorite());
    }
  },
  mounted() {
    this.existFavorite();
  },
  methods: {
    saveCollect() {
      if (this.isFavorite) return;
      this.$refs.dirSelector.show();
    },
    async ensure(currentNode) {
      const { filepath, id, name, name2 } = this.dataSource;
      const Params = JSON.stringify({ filepath, id, name, name2 });
      const res = await CommonService.add(Category.ResourceFavoriteDir, Category.OutsourcingDir, currentNode.DirID, {
        Params,
        Md5: WinForm.md.getMD5Hash(Params)
      });
      if (res) {
        Message({
          message: '添加成功',
          type: 'success',
        })
        this.existFavorite();
      }
    },
    async existFavorite() {
      if (!this.isShow) return false;
      const { filepath, id, name, name2 } = this.dataSource;
      const Params = JSON.stringify({ filepath, id, name, name2 });
      const res = await FavoriteService.getModelParamsExists(WinForm.md.getMD5Hash(Params), 'std');
      if (res.code === 0) {
        this.isFavorite = res.data || false;
      }
    }
  }
}
</script>
